// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"833e567fbf4e2e34","5405":"95cc8b295e8c2fe2","9622":"95cc8b295e8c2fe2"}[chunkId] + ".css";
};